// extracted by mini-css-extract-plugin
module.exports = {"fieldsContainer":"SingleAsset_fieldsContainer__NgfMm","dataStreamId":"SingleAsset_dataStreamId__R2irk"};